"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logger = exports.createLogger = void 0;

var _consola = _interopRequireDefault(require("consola"));

var _global = require("./global");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// Import only the reporters we need for the browser, firstly so that webpack
// can tree-shake unused code, and secondly becase some of the consola reporters
// we extend throw errors when imported in the browser
var reporters = typeof window === 'undefined' ? [process.env.NODE_ENV === 'production' ? require('./reporters/datadog') : require('./reporters/fancy')] : [require('./reporters/datadog'), require('./reporters/browser')];

var getReporters = function getReporters(name, meta) {
  return reporters.map(function (_ref) {
    var Reporter = _ref["default"];
    return new Reporter(name, meta);
  });
};
/**
 * Get the logger options.
 */


var getOpts = function getOpts(name, meta) {
  return {
    level: 'trace',
    // Log levels are filtered when a log function is called
    reporters: getReporters(name, meta)
  };
};
/**
 * Create a logger.
 */


var createLogger = function createLogger(name, meta) {
  var opts = getOpts(name, meta);

  if (!name) {
    throw new Error("Logger must be created with a name as the first argument, got ".concat(name));
  }

  var logger = _consola["default"].create(opts); // Branch off to create a logger with a new name


  logger.withName = function (newName) {
    return _consola["default"].create(getOpts(newName, meta));
  }; // Branch off to create a logger with new metadata


  logger.withMeta = function (newMeta) {
    return _consola["default"].create(getOpts(name, newMeta));
  };

  return logger;
};

exports.createLogger = createLogger;
(0, _global.setGlobalLogger)(createLogger('global'));

var _getGlobalObject = (0, _global.getGlobalObject)(),
    logger = _getGlobalObject.logger;

exports.logger = logger;